import React from "react";
import "./footer.css";
import { ReactComponent as FooterLogoIcon } from "../../assets/FooterLogoIcon.svg";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main-container">
        <div>
          <Link to={"/"}>
            <FooterLogoIcon />
          </Link>
        </div>
        <div className="link-wrapper">
          <div>
            <p className="footer-title">Explore</p>
            <Link to={"/"}>Home</Link>
            <Link to={"/file-claim"}>File a claim</Link>
            <Link to={"/claimstatus"}>Claim Status</Link>
          </div>
          <div>
            <p className="footer-title">About</p>
            <Link to={"/about-us"}>About us</Link>
            <Link to={"/faq"}>FAQs</Link>
            <Link to={"/contact-us"}>Contact us</Link>
            <Link to={"/disclaimer"}>Disclaimer</Link>
          </div>
        </div>

        <div>
          <p className="footer-title">Contact information</p>
          <a href="mailto:claims@flyandclaim.com">claims@flyandclaim.com</a>
          <a href="tel:8452120404">845-212-0404</a>
        </div>
      </div>

      <div className="copyright-section">
        <p>Copyright © Fly ‘n Claim 2024</p>
        <div className="copyright-section-links">
          <Link style={{ fontSize: "12px" }} to={"/disclaimer"}>
            Terms of use
          </Link>
          <Link style={{ fontSize: "12px" }} to={"/privacy"}>
            Privacy policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
